import { createActions } from 'redux-actions';

export const { articlesFetch, articlesSet } = createActions('ARTICLES_FETCH', 'ARTICLES_SET', {
  prefix: 'ARTICLE_PAGE',
});
